export enum PARTNER_TYPE {
  AFFILIATE = "AFFILIATE",
  CONTRIBUTOR = "CONTRIBUTOR"
}

export enum PARTNER_LEVEL {
  STANDARD = "STANDARD",
  BRONZE = "BRONZE",
  SILVER = "SILVER",
  GOLD = "GOLD"
}
